// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { InputBox } from '@imprivata-cloud/components';
import { useId } from 'react';
import CopyButton from '../copyButton/copyButton';
import './ReadOnlyCredentialRow.less';

interface ReadOnlyCredentialRowProps {
  label: string;
  value: string;
  ariaLabel?: string;
}

const ReadOnlyCredentialRow = ({ label, value, ariaLabel }: ReadOnlyCredentialRowProps) => {
  const inputId = useId();
  return (
    <div className="credential-row">
      {/* Not InputBox's `label`: that renders inside `.impr-input-box`, which the IDV modal
          styles as a fixed-height field. */}
      {label && <label htmlFor={inputId}>{label}</label>}
      <div className="input-with-copy">
        <InputBox id={inputId} value={value} readOnly size="large" />
        <CopyButton
          textToCopy={value}
          dynamicLabel={{ initialLabel: '', labelAfterClick: '', dynamicLabelDuration: 2000 }}
          {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
        />
      </div>
    </div>
  );
};

export default ReadOnlyCredentialRow;
